import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ContentMapExtensionStore } from './store/ContentMapExtensionStore';
import * as styles from './ContentMapExtension.css';
import { LoggingService } from '../../services/LoggingService';
import { IAContentMap } from '../contentMap';
import { Helper } from '../../Helper';
import { IAIcon } from '../icon/Icon';

export interface IContentMapExtensionProps {
  contentMapExtensionStore?: ContentMapExtensionStore;
}

@inject('contentMapExtensionStore')
@observer
export class ContentMapExtension extends React.Component<IContentMapExtensionProps> {

  constructor(props: IContentMapExtensionProps) {
    super(props);
    LoggingService.init(this.props.contentMapExtensionStore.environment);
    this.props.contentMapExtensionStore.currentUrl = location.href;
    window.addEventListener("click", () => {
      setTimeout(() => {
        if (location.href.toLowerCase().indexOf("mode=edit") !== -1) {
          this.props.contentMapExtensionStore.hidden = true;
        } else {
          this.props.contentMapExtensionStore.hidden = false;
        }
      }, 1000);
    });
    setInterval(() => {
      if (this.props.contentMapExtensionStore.currentUrl !== location.href) {
        this.props.contentMapExtensionStore.currentUrl = location.href;
        this.props.contentMapExtensionStore.showContentMap = false;
        setTimeout(() => {
          this.urlChanged();
        }, 500);
      }
    }, 1000);
    this.shouldHideContentMapButton();
    this.checkLocationChange();
  }

  private urlChanged(): void {
    this.props.contentMapExtensionStore.showContentMapContent = false;
    this.shouldHideContentMapButton();
  }

  private shouldHideContentMapButton(): void {
    if (window?.location?.pathname?.toLocaleLowerCase()?.indexOf("/sitepages/") === -1 && !window?.location.href?.includes("localhost:3000")) {
      this.props.contentMapExtensionStore.hidden = true;
    } else {
      this.props.contentMapExtensionStore.hidden = false;
    }
  }

  private checkLocationChange(): void {
    window.addEventListener('popstate', () => this.urlChanged());
    window.addEventListener('replaceState', () => this.urlChanged());
    window.addEventListener('pushState', () => this.urlChanged());
    const { pushState, replaceState } = window.history;
    window.history.pushState = (...args) => {
      pushState.apply(window.history, args);
      window.dispatchEvent(new Event('pushState'));
    };
    window.history.replaceState = (...args) => {
      replaceState.apply(window.history, args);
      window.dispatchEvent(new Event('replaceState'));
    };
  }

  public componentDidMount(): void {
    document.addEventListener('keydown', event => this.escFunction(event), false);
  }

  public componentWillUnmount(): void {
    document.removeEventListener('keydown', event => this.escFunction(event), false);
  }

  private escFunction(event: any): void {
    if (event.keyCode === 27) {
      this.props.contentMapExtensionStore.showContentMap = false;
    }
  }

  public render(): JSX.Element {
    let top = 0;
    if (Helper.getDisplayEnvironment() === "Sharepoint") {
      top = 48;
    }
    if ((Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar") && !document.getElementById("IA_navigator_vertical_menu")) {
      top = 88;
    }
    let width = window.innerWidth;
    if (document.getElementById("sp-appBar") && document.getElementById("spPageChromeAppDiv") && document.getElementById("spPageChromeAppDiv").offsetWidth < window.innerWidth) {
      width = width - 47;
    }
    return !this.props.contentMapExtensionStore.hidden ? (
      <div>
        {this.props.contentMapExtensionStore.showContentMap &&
          <div
            className={styles.IA_contentMapBackgroundOverlay}
            onClick={() => this.props.contentMapExtensionStore.showContentMap = false}
          />
        }
        <div
          id="IA_ContentMapExtension"
          className={styles.IA_contentMapWrapper}
          style={{
            right: this.props.contentMapExtensionStore.showContentMap ? 0 : -window.innerWidth,
            width: width,
            top: top,
            height: `calc(100% - ${top}px)`

          }}
        >
          {(this.props.contentMapExtensionStore.showContentMapContent || this.props.contentMapExtensionStore.hasLoaded) &&
            <IAContentMap
              environment={this.props.contentMapExtensionStore.environment}
              isMobile={this.props.contentMapExtensionStore.isMobile}
              tenant={this.props.contentMapExtensionStore.tenant}
              token={this.props.contentMapExtensionStore.token}
              instance={this.props.contentMapExtensionStore.instance}
              highlightColor={this.props.contentMapExtensionStore.highlightColor}
              hasDarkBackground={false}
              isExtension
              fontSlots={this.props.contentMapExtensionStore.fontSlots}
              styles={this.props.contentMapExtensionStore.styles}
              onClick={() => {
              }}
            />
          }
        </div>
        {this.props.contentMapExtensionStore.showContentMap &&
          <a
            href={`${location.origin}/sites/${this.props.contentMapExtensionStore.instance.instanceName}`}
            onClick={(e) => {
              if (this.props.contentMapExtensionStore.isMobile) {
                e.preventDefault();
              }
            }}
          >
            <div
              className={styles.IA_contentMapMinimizedButton}
              style={{
                backgroundColor: this.props.contentMapExtensionStore.highlightColor,
                top: this.props.contentMapExtensionStore.isMobile ? undefined : "calc(50% - 96px)",
                bottom: this.props.contentMapExtensionStore.isMobile ? 0 : undefined,
                right: this.props.contentMapExtensionStore.isMobile ? 48 : undefined,
                cursor: "default"
              }}
            >
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Map/SVG/ic_fluent_map_24_regular.svg"
                size={this.props.contentMapExtensionStore.showContentMap ? 32 : 35}
                color={Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.contentMapExtensionStore.highlightColor, "#ffffff", "#333333")}
                style={{
                  padding: 8
                }}
              />
            </div>
          </a>
        }
        <div
          className={styles.IA_contentMapMinimizedButton}
          style={{
            top: this.props.contentMapExtensionStore.isMobile ? undefined : "calc(50% - 48px)",
            backgroundColor: this.props.contentMapExtensionStore.showContentMap ? "#b4b4b4" : this.props.contentMapExtensionStore.highlightColor
          }}
          onClick={() => {
            this.props.contentMapExtensionStore.hasLoaded = true;
            this.props.contentMapExtensionStore.showContentMap = !this.props.contentMapExtensionStore.showContentMap;
            if (this.props.contentMapExtensionStore.showContentMap) {
              this.props.contentMapExtensionStore.showContentMapContent = true;
            }
          }}
        >
          <IAIcon
            title={this.props.contentMapExtensionStore.showContentMap ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Dismiss/SVG/ic_fluent_dismiss_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Map/SVG/ic_fluent_map_24_regular.svg"}
            size={this.props.contentMapExtensionStore.showContentMap ? 32 : 35}
            color={Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.contentMapExtensionStore.highlightColor, "#ffffff", "#333333")}
            style={{
              padding: 8
            }}
          />
        </div>
      </div>
    ) : (<div></div>)
  }
}